import {RouteRecordRaw } from 'vue-router'
// 路由

/**
 * meta:{
 *     title:'登录', 页面标题/菜单标题
 *     icon:'',     菜单图标
 *     hidden:true, 是否在菜单中以隐藏
 *     hiddenTab:true 是否在tab栏中隐藏
 *     role: 角色权限,
 *     mode: 版本  base  tq台球
 * }
 */

 export const commonRoutes: Array<RouteRecordRaw> = [
    {
      path: '/',
      component: ()=>import('@/layout/index.vue'),
      redirect:'/index',
      meta:{
        title:'首页',
        icon:'stat'
      },
      children: [{
        path:'/index',
        name:'homeIndex',
        component: ()=>import('@/views/Home/index.vue'),
        meta:{
          title:'首页',
          icon:''
        },
      },{
        path:'/home',
        name:'home',
        component: ()=>import('@/views/Home/home.vue'),
        meta:{
          title:'数据',
          icon:'',
          mode: ['base']
        },
      }]
    },
    // 登录
    {
      path: '/login',
      name:'login',
      component: ()=>import('@/views/Login/index.vue'),
      meta:{
        title:'登录',
        icon:'',
        hidden:true,
        hiddenTab:true
      }
    },
   
    // 个人中心
    {
      path: '/user',
      component: ()=>import('@/layout/index.vue'),
      redirect:'/user/userInfo',
      meta:{
        title:'个人中心',
        icon:'user',
        hidden:true,
        hiddenTab:true
      },
      children: [{
        path:'userInfo',
        name:'userInfo',
        component: ()=>import('@/views/userCenter/userInfo.vue'),
        meta:{
          title:'个人中心',
          icon:''
        },
      }]
    },
    //  收银管理
    
    {
      path: '/cashier',
      component: ()=>import('@/layout/index.vue'),
      meta:{
        title:'收银台',
        icon:'cashier',
        role:["机构",'union','mec_staff','mec_manager','outside'],
      },
      children: [{
        path:'tqVenue',
        name:'tqVenue',
        component: ()=>import('@/views/cashierManage/tqVenue.vue'),
        meta:{
          title:'开台',
          icon:'',
          mode: ['tq']
        },
      },
      {
        path:'tqCashier',
        name:'tqCashier',
        component: ()=>import('@/views/cashierManage/tqCashier.vue'),
        meta:{
          title:'商品服务',
          icon:'',
          hidden:true,
          hiddenTab:true
        },
      },{
        path:'venue',
        name:'cashier_venue',
        component: ()=>import('@/views/cashierManage/venue.vue'),
        meta:{
          title:'场馆预订',
          icon:'',
          mode: ['base']
        },
      },{
        path:'courseIndex',
        name:'cashier_courseIndex',
        component: ()=>import('@/views/cashierManage/courseIndex.vue'),
        meta:{
          title:'课程收银',
          icon:'',
          mode: ['base']
        },
      },{
        path:'shop',
        name:'cashier_shop',
        component: ()=>import('@/views/cashierManage/shop.vue'),
        meta:{
          title:'馆内小店',
          icon:'',
          mode: ['base']
        },
      },{
        path:'writeoff',
        name:'writeoff',
        component: ()=>import('@/views/cashierManage/writeoffManage.vue'),
        meta:{
          title:'核销管理',
          icon:'',
          mode: ['base']
        },
      },{
        path:'orderEntry',
        name:'cashier_orderEntry',
        component: ()=>import('@/views/cashierManage/orderEntry.vue'),
        meta:{
          title:'订单录入',
          icon:'',
          mode: ['base']
        },
      }]
    },
//  进度管理
  {
    path: '/progress',
    component: ()=>import('@/layout/index.vue'),
    redirect:'/progress/index',
    meta:{
      title:'进度汇报',
      icon:'report',
      hidden:true,
      hiddenTab:true
    },
    children: [{
      path:'index',
      name:'progress_index',
      component: ()=>import('@/views/progressManage/index.vue'),
      meta:{
        title:'进度汇报',
        icon:'',
        hidden:true,
      hiddenTab:true
      },
    }]
  },
    //  教学
    {
      path: '/teaching',
      component: ()=>import('@/layout/index.vue'),
      redirect:'/teaching/list',
      meta:{
        title:'课程教学',
        icon:'teaching',
        role: ["机构",'union',"mec_staff",'mec_manager','outside'],
        mode: ['base']
      },
      children: [{
        path:'list',
        name:'course_list',
        component: ()=>import('@/views/courseManage/list.vue'),
        meta:{
          title:'课包管理',
          icon:''
        },
      },{
        path:'courseTable',
        name:'teaching_courseTable',
        component: ()=>import('@/views/teachingManage/courseTable.vue'),
        meta:{
          title:'课程表',
          icon:''
        },
      },{
        path:'schedule',
        name:'teaching_schedule',
        component: ()=>import('@/views/teachingManage/schedule.vue'),
        meta:{
          title:'课程排课',
          icon:''
        },
      },{
        path:'userAppoint',
        name:'teaching_userAppoint',
        component: ()=>import('@/views/teachingManage/userAppoint.vue'),
        meta:{
          title:'课程核销',
          icon:'',
        },
      },{
        path:'classList',
        name:'teaching_classList',
        component: ()=>import('@/views/teachingManage/classList.vue'),
        meta:{
          title:'班级管理',
          icon:''
        },
      },{
        path:'studentList',
        name:'teaching_studentList',
        component: ()=>import('@/views/teachingManage/studentList.vue'),
        meta:{
          title:'学员管理',
          icon:''
        },
      },
      {
        path:'masterDetails',
        name:'master_details',
        component: ()=>import('@/views/teachingManage/masterAppointDetails.vue'),
        meta:{
          title:'课程详情',
          icon:'',
          hiddenTab: true,
          hidden: true
        },
      },{
        path:'studentDetails',
        name:'teaching_studentDetails',
        component: ()=>import('@/views/teachingManage/studentDetails.vue'),
        meta:{
          title:'学员详情',
          icon:'',
          hidden:true,
          hiddenTab:true
        },
      },{
        path:'classDetails',
        name:'teaching_classDetails',
        component: ()=>import('@/views/teachingManage/classDetails.vue'),
        meta:{
          title:'班级详情',
          icon:'',
          hidden:true,
          hiddenTab:true
        },
      }]
    },
     //  会员卡管理
     {
      path: '/card',
      component: ()=>import('@/layout/index.vue'),
      redirect:'/card/user',
      meta:{
        title:'会员管理',
        icon:'card',
        role: ["机构",'union','mec_manager','outside'],
      },
      children: [{
        path:'user',
        name:'card_user',
        component: ()=>import('@/views/cardManage/memberUser.vue'),
        meta:{
          title:'会员用户',
          icon:''
        },
      },{
        path:'send',
        name:'card_send',
        component: ()=>import('@/views/cardManage/sendCard.vue'),
        meta:{
          title:'发卡/购卡',
          icon:''
        },
      },{
        path:'list',
        name:'card_list',
        component: ()=>import('@/views/cardManage/list.vue'),
        meta:{
          title:'会员卡管理',
          icon:''
        },
      },{
        path:'rechrule',
        name:'rechrule',
        component: ()=>import('@/views/cardManage/rechRule.vue'),
        meta:{
          title:'充值活动',
          icon:'',
          role: ["机构",'mec_manager'],
          mode: ['tq']
        },
      },{
        path:'add',
        name:'card_add',
        component: ()=>import('@/views/cardManage/add.vue'),
        meta:{
          title:'编辑会员卡',
          icon:'',
          hidden:true,
          hiddenTab:true
        },
      },{
        path:'carduser',
        name:'card_user_details',
        component: ()=>import('@/views/cardManage/cardDetails.vue'),
        meta:{
          title:'会员详情',
          icon:'',
          hidden:true,
          hiddenTab:true
        },
      }]
    },
    {
      path: '/order',
      component: ()=>import('@/layout/index.vue'),
      redirect:'/order/list',
      meta:{
        title:'订单管理',
        icon:'order',
        role: ["机构",'union','mec_manager','outside'],
      },
      children: [{
        path:'list',
        name:'order_list',
        component: ()=>import('@/views/orderManage/list.vue'),
        meta:{
          title:'订单列表',
          icon:''
        },
      },{
        path:'details',
        name:'order_details',
        component: ()=>import('@/views/orderManage/details.vue'),
        meta:{
          title:'订单详情',
          icon:'',
          hidden:true,
          hiddenTab:true
        },
      },{
        path:'refundList',
        name:'refundList',
        component: ()=>import('@/views/refundManage/refundList.vue'),
        meta:{
          title:'订单退款',
          icon:''
        },
      },{
       path:'refundDetails',
       name:'refundDetails',
       component: ()=>import('@/views/refundManage/refundDetails.vue'),
       meta:{
         title:'订单详情',
         icon:'',
         hidden:true,
         hiddenTab:true
       },
     },{
        path:'data',
        name:'order_data',
        component: ()=>import('@/views/orderManage/data.vue'),
        meta:{
          title:'数据报表',
          icon:''
        },
      }]
    },

     //  门店
     {
      path: '/mallMec',
      component: ()=>import('@/layout/index.vue'),
      redirect:'/mallMec/list',
      meta:{
        title:'门店管理',
        icon:'income',
        role:['mall'],
        mode: ['base']
      },
      children: [{
        path:'list',
        name:'mallMecList',
        component: ()=>import('@/views/mallMechanism/list.vue'),
        meta:{
          title:'门店列表',
          icon:''
        },
      },{
        path:'details',
        name:'mallMecDetails',
        component: ()=>import('@/views/mallMechanism/details.vue'),
        meta:{
          title:'门店详情',
          icon:'',
          hidden:true,
          hiddenTab:true
        },
      }]
    },
     
        //  教练管理
        {
          path: '/coach',
          component: ()=>import('@/layout/index.vue'),
          redirect:'/coach/list',
          meta:{
            title:'门店教练',
            icon:'coach',
            role: ["机构",'union',"mec_staff",'mec_manager','outside'],
          },
          children: [{
            path:'list',
            name:'coach_list',
            component: ()=>import('@/views/coachManage/mecCoach.vue'),
            meta:{
              title:'门店教练',
              icon:''
            },
          },
          {
            path:'expertStats',
            name:'expertStats',
            component: ()=>import('@/views/coachManage/expertStats.vue'),
            meta:{
              title:'教练数据',
              icon:'',
              mode: ['tq']
            },
          },
          {
            path:'coop',
            name:'coop_coach',
            component: ()=>import('@/views/coachManage/coopCoach.vue'),
            meta:{
              title:'合作教练',
              icon:'',
              mode: ['base']
            },
          },{
            path:'details',
            name:'coach_details',
            component: ()=>import('@/views/coachManage/details.vue'),
            meta:{
              title:'教练详情',
              icon:'',
              hiddenTab: true,
              hidden: true
            },
          },{
            path:'expertOrderList',
            name:'expertOrderList',
            component: ()=>import('@/views/coachManage/expertOrderList.vue'),
            meta:{
              title:'接单明细',
              icon:'',
              hiddenTab: true,
              hidden: true
            },
          }
          ]
        },
        
    {
      path: '/device',
      component: ()=>import('@/layout/index.vue'),
      redirect:'/device/list',
      meta:{
        title:'设备管理',
        icon:'device',
        role: ["机构",'union',"mec_staff",'mec_manager','outside'],
      },
      children: [{
        path:'list',
        name:'deviceList',
        component: ()=>import('@/views/deviceManage/list.vue'),
        meta:{
          title:'设备列表',
          icon:''
        },
      },{
        path:'details',
        name:'deviceDetails',
        component: ()=>import('@/views/deviceManage/details.vue'),
        meta:{
          title:'设备详情',
          icon:'',
          hiddenTab: true,
          hidden: true
        },
      }]
    },
     //  场地管理
     {
      path: '/venue',
      component: ()=>import('@/layout/index.vue'),
      redirect:'/venue/info',
      meta:{
        title:'门店管理',
        icon:'venue',
        role: ["机构",'union','mec_manager','outside'],
      },
      children: [{
        path:'info',
        name:'mec_info',
        component: ()=>import('@/views/mechanismManage/info.vue'),
        meta:{
          title:'门店信息设置',
          icon:''
        },
      },{
        path:'venue',
        name:'venue',
        component: ()=>import('@/views/venueManage/venue/venue.vue'),
        meta:{
          title:'场地管理',
          icon:''
        },
      },{
        path:'appo',
        name:'venue_appo',
        component: ()=>import('@/views/venueManage/appointment/list.vue'),
        meta:{
          title:'预约记录',
          icon:''
        },
      },{
        path:'scheduling',
        name:'venue_scheduling',
        component: ()=>import('@/views/venueManage/scheduling/scheduling.vue'),
        meta:{
          title:'场地排期',
          icon:'',
          // hidden:true,
          // hiddenTab:true
        },
      }]
    },
     //  收益管理
     {
      path: '/shop',
      component: ()=>import('@/layout/index.vue'),
      redirect:'/shop/list',
      meta:{
        title:'商品管理',
        icon:'shop',
        role: ["机构",'union','mec_manager','outside'],
      },
      children: [{
        path:'list',
        name:'productList',
        component: ()=>import('@/views/shopManage/productList.vue'),
        meta:{
          title:'商品管理',
          icon:''
        },
      },{
        path:'edit',
        name:'productEdit',
        component: ()=>import('@/views/shopManage/editProduct.vue'),
        meta:{
          title:'商品管理',
          icon:'',
          hiddenTab: true,
          hidden: true
        },
      }
    ]
    },
     //  收益管理
     {
      path: '/income',
      component: ()=>import('@/layout/index.vue'),
      redirect:'/income/incomeManage',
      meta:{
        title:'收益管理',
        icon:'income',
        role:["机构",'union','mec_manager']
      },
      children: [{
        path:'incomeManage',
        name:'incomeManage',
        component: ()=>import('@/views/incomeManage/index.vue'),
        meta:{
          title:'收益详情',
          icon:''
        },
      },
      // {
      //   path:'account',
      //   name:'account',
      //   component: ()=>import('@/views/incomeManage/account.vue'),
      //   meta:{
      //     title:'提现账户',
      //     icon:''
      //   },
      // }
    ]
    },
     //  优惠券
     {
      path: '/coupon',
      component: ()=>import('@/layout/index.vue'),
      redirect:'/coupon/list',
      meta:{
        title:'优惠券',
        icon:'coupon',
        role: ["机构",'union','mec_manager','outside'],
        mode: ['base']
      },
      children: [{
        path:'list',
        name:'coupon_list',
        component: ()=>import('@/views/couponManage/list.vue'),
        meta:{
          title:'优惠券列表',
          icon:''
        },
      },{
        path:'userCoupon',
        name:'userCoupon',
        component: ()=>import('@/views/couponManage/userCoupon.vue'),
        meta:{
          title:'已领优惠券',
          icon:''
        },
      }]
    },
    {
      path: '/mallincome',
      component: ()=>import('@/layout/index.vue'),
      redirect:'/mallincome/incomeManage',
      meta:{
        title:'收益管理',
        icon:'income',
        role:['mall']
      },
      children: [{
        path:'mecCoupon',
        name:'mecCoupon',
        component: ()=>import('@/views/couponManage/list.vue'),
        meta:{
          title:'优惠券',
          icon:''
        },
      },{
        path:'mallMecOrder',
        name:'mallMecOrder',
        component: ()=>import('@/views/mallIncome/order.vue'),
        meta:{
          title:'门店订单',
          icon:''
        },
      }]
    },
    //  运营管理
    {
      path: '/operate',
      component: ()=>import('@/layout/index.vue'),
      redirect:'/operate/rechrule',
      meta:{
        title:'运营管理',
        icon:'report',
        role: ['机构','mec_manager'],
        mode: ['base']
      },
      children: [{
        path:'rechrule',
        name:'rechrule',
        component: ()=>import('@/views/cardManage/rechRule.vue'),
        meta:{
          title:'充值活动',
          icon:''
        },
      },{
        path:'activity',
        name:'ope_activity',
        component: ()=>import('@/views/groupingManage/list.vue'),
        meta:{
          title:'活动管理',
          icon:''
        },
      },{
        path:'activity/add',
        name:'add_activity',
        component: ()=>import('@/views/groupingManage/create.vue'),
        meta:{
          title:'发起活动',
          icon:'',
          hidden:true,
          hiddenTab:true
        },
      },{
        path:'activity/d',
        name:'ope_activity_d',
        component: ()=>import('@/views/groupingManage/details.vue'),
        meta:{
          title:'活动详情',
          icon:'',
          hidden:true,
          hiddenTab:true
        },
      },{
        path:'activityDetails',
        name:'ope_activityD',
        component: ()=>import('@/views/operateManage/activityDetails.vue'),
        meta:{
          title:'活动详情',
          icon:'',
          hidden:true,
          hiddenTab:true
        }
      },{
        path:'invite',
        name:'ope_invite',
        component: ()=>import('@/views/operateManage/invite.vue'),
        meta:{
          title:'学员导入',
          icon:''
        },
      },]
    },
     //  消息管理
     {
      path: '/msg',
      component: ()=>import('@/layout/index.vue'),
      redirect:'/msg/msg',
      meta:{
        title:'消息管理',
        icon:'message',
        role: ["机构",'union','mec_manager','outside']
      },
      children: [{
        path:'msg',
        name:'sysMessage',
        component: ()=>import('@/views/messageManage/sysMessage.vue'),
        meta:{
          title:'我的消息',
          icon:''
        },
      },{
        path:'bind',
        name:'wxbind',
        component: ()=>import('@/views/messageManage/bindWx.vue'),
        meta:{
          title:'公众号通知设置',
          icon:''
        },
      }]
    },
     //  员工管理
     {
      path: '/staff',
      component: ()=>import('@/layout/index.vue'),
      redirect:'/staff/staffManage',
      meta:{
        title:'员工管理',
        icon:'staff',
        role: ["机构",'union','mec_manager','outside'],
      },
      children: [{
        path:'staffManage',
        name:'staffManage',
        component: ()=>import('@/views/staffManage/index.vue'),
        meta:{
          title:'员工管理',
          icon:''
        },
      }]
    }, 


    //大屏
    {
      path: '/visual',
      component: ()=>import('@/layout/index.vue'),
      redirect:'/visual/index',
      meta:{
        title:'数据大屏',
        icon:'data',
        role: ["机构",'mall','mec_manager'],
        mode: ['base']
      },
      children: [{
        path:'index',
        name:'visual_index',
        component: ()=>import('@/views/visualization/index.vue'),
        meta:{
          title:'大屏',
          icon:''
        },
      }]
    },
     //大屏
     {
      path: '/tools',
      component: ()=>import('@/layout/index.vue'),
      meta:{
        title:'工具',
        icon:'',
        hidden:true,
        hiddenTab:true
      },
      children: [{
        path:'compress',
        name:'compress',
        component: ()=>import('@/views/tools/imgCompress/imgCompress.vue'),
        meta:{
          title:'压缩图片',
          icon:'',
          hidden:true,
          hiddenTab:true
        },
      }]
    },
    {
      path: '/visual/mallData',
      component: ()=>import('@/views/visualization/mallData/mallData.vue'),
      meta:{
        title:'商场收益大屏',
        icon:'',
        hidden:true,
        hiddenTab:true
      }
    },
    {
      path: '/visual/mallDatat',
      component: ()=>import('@/views/visualization/mallData/mallDatat.vue'),
      meta:{
        title:'商场收益大屏',
        icon:'',
        hidden:true,
        hiddenTab:true
      }
    },
    {
      path: '/visual/mallMect',
      component: ()=>import('@/views/visualization/mechanismData/mallMect.vue'),
      meta:{
        title:'商场课程数据大屏',
        icon:'',
        hidden:true,
        hiddenTab:true
      }
    },
    {
      path: '/visual/mallMecCourseData',
      component: ()=>import('@/views/visualization/mechanismData/mallMecCourseData.vue'),
      meta:{
        title:'商场课程数据大屏',
        icon:'',
        hidden:true,
        hiddenTab:true
      }
    },
    {
      path: '/visual/mechanismData',
      component: ()=>import('@/views/visualization/mechanismData/mechanismData.vue'),
      meta:{
        title:'门店数据大屏',
        icon:'',
        hidden:true,
        hiddenTab:true
      }
    },
    {
      path: '/:path(.*)*',
      component: ()=>import('@/views/err/404.vue'),
      meta:{
        title:'404',
        icon:'',
        hidden:true,
        hiddenTab:true
      }
    }
  ]